
$(document).ready(function() {
	// Append info popup to body if it doesn't exist
	// if ($('#element-info').length == 0) {
	// 	$('body').append('<div id="element-info"><div id="element-info-arrow"></div><div id="element-info-content"></div></div>');
	// }

	// Process .info-content divs inside the template
	$('.info-content').each(function() {
		var rel = $(this).attr('rel');
		addInfoIcon($(rel), QueryString.module, rel);
	});

	// If needed, load the info icons
	if ($('[data-info]').length > 0) {
		loadInfoIcons();
	}

	$(document).on('click', function(e) {
		if ($(e.target).closest('#element-info').length === 0) {
			$('.info-active').trigger('click');
		}
	});
});

function loadInfoIcons() {
	var modules = [];

	$('[data-info]').each(function() {
		var module = $(this).data('module');

		if (module === undefined) {
			module = QueryString.module;
			$(this).attr('data-module', module);
		}

		if (modules.indexOf(module) < 0) {
			modules.push(module);
		}
	});

	$.each(modules, function(key, module) {
		$.get('lib/infotext.php?module=' + module.toLowerCase(), function(data) {
			$.each(data.split(','), function(i, field) {
				$('[data-info="' + field + '"][data-module="' + module + '"]').each(function() {
					addInfoIcon($(this), module, field);
				});
			});
		});
	});
}

function addInfoIcon($element, module, field) {
	if ($element.length == 0) {
		return;
	}

	if ($element.parent().find('.element-info-icon').length > 0) {
		return;
	}

	var $icon = $('<span class="element-info-icon" rel="' + field + '" data-module="' + module + '">' +
		'<i class="fa fa-info-circle"></i></span>');

	$icon.on('click', function(e) {
		e.stopPropagation();
		toggleInfo($icon);
	});

	$element.parent().append($icon);
}

function toggleInfo($icon) {
	var $info      = $('#element-info');
	var rel        = $icon.attr('rel');
	// var doc_width  = $(document).width();
	// var ele_pos    = $icon.offset();
	// var ele_width  = $icon.outerWidth();
	// var info_width = $info.width();
	// var info_left  = $info.position().left;
	// var info_top   = $info.position().top;
	var module     = $icon.data('module');

	// $('.info-active').not($icon).removeClass('info-active');

	// var ele_left   = ele_pos.left;
	// var ele_top    = ele_pos.top;

	// $info.stop(true, true).fadeOut('fast', function() {
	// 	var new_left = ele_left + ele_width + 5;
	// 	var new_top  = ele_top - 1;
		var info_id  = rel;
	//
	// 	if (new_left > doc_width - info_width - 20) {
	// 		new_left = doc_width - info_width - 20;
	// 		new_top  += 2;
	// 	}
	//
	// 	if ($icon.hasClass('info-active')) {
	// 		$icon.removeClass('info-active');
	// 		return;
	// 	}
	//
	// 	$info.css({
	// 		width: info_width,
	// 		left: new_left,
	// 		top: new_top
	// 	});

		if ($(rel).length > 0) {
			// $info.fadeIn('fast');
			// $('#element-info-content').html($('.info-content[rel="' + rel + '"]').html());

			$icon.tooltip({
				offset: "0, 5",
				html: true,
				trigger: 'manual',
				title: $('.info-content[rel="' + rel + '"]').html()
			});
			$icon.tooltip('toggle');

		} else {
			$.get('lib/infotext.php?module=' + module.toLowerCase() + '&info_id=' + info_id, function(data) {
				// $info.fadeIn('fast');
				// $('#element-info-content').html(data);

				$icon.tooltip({
					offset: "0, 5",
					html: true,
					trigger: 'manual',
					title: data,
				});
				$icon.tooltip('toggle');
			});
		}

		// $icon.addClass('info-active');
	// });
}

/**
 * Get parameter value from url
 */
if (typeof(QueryString) == 'undefined') {
	var QueryString = function () {
		var query_string = {};
		var query        = window.location.search.substring(1);
		var vars         = query.split("&");
		
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			
			// If first entry with this name
			if (typeof query_string[pair[0]] === "undefined") {
				query_string[pair[0]] = pair[1];
				
				// If second entry with this name
			} else if (typeof query_string[pair[0]] === "string") {
				var arr = [ query_string[pair[0]], pair[1] ];
				query_string[pair[0]] = arr;
				
				// If third or later entry with this name
			} else {
				query_string[pair[0]].push(pair[1]);
			}
		}
		
		return query_string;
	} ();
}
